<template>
  <div class="help_box flex" ref="multipleTable">

    <div class="item">
      <span class="txt">物料编码：</span>
      <el-input v-model="fromData.materialCode" placeholder="暂无物料编码" :disabled="true"></el-input>
    </div>

    <div class="item">
      <span class="txt">物料描述：</span>
      <el-input v-model="fromData.materialDesc" placeholder="暂无物料描述" :disabled="true"></el-input>
    </div>

    <div class="item">
      <span class="txt">订单数量：</span>
      <el-input v-model="fromData.orderQuantityTotal" placeholder="暂无" :disabled="true" style="margin-left:2%"></el-input>
      <el-input v-model="fromData.entryUnitDesc" placeholder="无" style="width:15%;margin-left:2%" :disabled="true"></el-input>
    </div>

    <div class="item">
      <span class="txt">剩余数量：</span>
      <el-input v-model="fromData.remainNum" placeholder="暂无" :disabled="true"></el-input>
    </div>

  </div>
</template>

<script>
import { fstockApi, customerApi, matterApi } from "api/base.js";
import { targetUnit } from "api/business.js";
import { mapState, mapActions } from "vuex";

export default {
  components: {},
  props: {
    noFromData: Object,
    factoryList: Array,
    fromData: Object,

    materialList: Array,
    distriChannelList: Array,
    salesPriceList: Array,
    priceUnitList: Array,
    basicUnitList: Array
  },
  data() {
    return {
      getAllPage: this.$store.state.getAllPage
    };
  },
  created() {
    //开始日期和结束日期默认今天
    // let nowData = new Date();
    // let arr = [this.fromData.validStartDate,this.fromData.validEndDate];
    // this.$set(this.fromData, "validDate", arr);
  },
  computed: {},
  methods: {
    ...mapActions("cache", [
      // "setMaterialList",
      // "setDistriChannelList",
      // "setSalesPriceList",
      // "setPriceUnitList",
      // "setBasicUnitList",
      "setSelectedProductOrderMaterial"
    ]),

    //取消选择
    cancelSelect() {
      this.$refs.multipleTable.cancelSelect();
    },

  }
};
</script>

<style>
</style>
